<div class="outer">
  <audio
    #audioPlayer
    [src]="audio().link | sanitize: 'url'"></audio>
  <button
    (click)="handlePlayPauseButtonClick()"
    [disabled]="loaderDisplay"
    class="play-pause"
    mat-icon-button
    [loading]="loaderDisplay">
    @if (!loaderDisplay) {
      <mat-icon
        aria-hidden="true"
        [class]="isPlaying ? 'pause-track' : 'play-track'">
        {{ isPlaying ? 'pause' : 'play_arrow' }}
      </mat-icon>
    }
  </button>
  <div class="inner">
    <div class="m-r-21">
      @if (duration !== DefaultDuration) {
        <span>
          {{ playerCurrentTime | secondsToMinutes }}
        </span>
      }
    </div>
    <mat-slider
      [min]="0"
      [max]="duration"
      style="width: 100%"
      class="voice-mail-slider"
      #ngSlider>
      <input
        matSliderThumb
        [value]="playerCurrentTime"
        (change)="handleSliderTimePositionChange(ngSliderThumb.value)"
        #ngSliderThumb="matSliderThumb" />
    </mat-slider>
    <div
      class="m-l-6"
      [hidden]="loaderDisplay">
      @if (duration !== DefaultDuration) {
        <span>
          {{ duration | secondsToMinutes }}
        </span>
      }
    </div>
    @if (message) {
      <button
        (click)="handleDownloadClick(message)"
        mat-icon-button>
        <mat-icon>download</mat-icon>
      </button>
      @if (showForwardButton) {
        <button
          mat-icon-button
          (click)="handleForwardVoicemailClick()">
          <mat-icon>phone_forwarded</mat-icon>
        </button>
      }
      @let disabled = message['sharedInfo']?.access === 'read';
      @if (showDeleteButton) {
        <button
          [ngClass]="{ disabled }"
          [disabled]="disabled"
          (click)="handleDeleteClick(message)"
          mat-icon-button>
          <mat-icon>delete_outline</mat-icon>
        </button>
      }
      @if (showRetrieveButton) {
        <button
          (click)="handleRetrieveVoicemailClick(message)"
          mat-icon-button>
          <mat-icon>restore_from_trash</mat-icon>
        </button>
      }
    }
  </div>
</div>
